import { render, staticRenderFns } from "./BiolinkPage.vue?vue&type=template&id=2e1d3dac&scoped=true&"
import script from "./BiolinkPage.vue?vue&type=script&lang=js&"
export * from "./BiolinkPage.vue?vue&type=script&lang=js&"
import style0 from "./BiolinkPage.vue?vue&type=style&index=0&id=2e1d3dac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d3dac",
  null
  
)

export default component.exports